var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.content)?_c('div',{attrs:{"id":"bandeau-component"}},[(_vm.content.display)?_c('div',{attrs:{"id":"bandeau"}},[_c('p',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.content.text)}})]):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }